import { useEffect } from 'react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import ReviewCard from '../components/ReviewCard';


const reviews = [
  { id: 1, text: "This is an amazing service. I loved the professionalism and dedication! Highly recommended for everyone looking for quality work.", name: "Sarah Johnson", image: "https://randomuser.me/api/portraits/women/1.jpg" },
  { id: 2, text: "Incredible experience. The team went above and beyond to meet our expectations. Truly grateful!", name: "Michael Lee", image: "https://randomuser.me/api/portraits/men/2.jpg" },
  { id: 3, text: "Fast, efficient, and very professional. I will definitely work with them again in the future.", name: "Emily Davis", image: "https://randomuser.me/api/portraits/women/3.jpg" },
  { id: 4, text: "Top-notch quality and amazing customer support. They were with me every step of the way.", name: "James Carter", image: "https://randomuser.me/api/portraits/men/4.jpg" },
  { id: 5, text: "Fantastic job! Everything was delivered on time and above expectations.", name: "Olivia Brown", image: "https://randomuser.me/api/portraits/women/5.jpg" },
  { id: 6, text: "Very pleased with the result. They turned our vision into reality with ease.", name: "Daniel Wilson", image: "https://randomuser.me/api/portraits/men/6.jpg" },
  { id: 7, text: "The whole process was smooth and seamless. Excellent communication throughout.", name: "Sophia Miller", image: "https://randomuser.me/api/portraits/women/7.jpg" },
  { id: 8, text: "They know what they’re doing and it shows in their work. Highly trustworthy team.", name: "William Turner", image: "https://randomuser.me/api/portraits/men/8.jpg" },
  { id: 9, text: "Exceeded expectations in every way. Thank you for the amazing results!", name: "Ava Martinez", image: "https://randomuser.me/api/portraits/women/9.jpg" },
];





export default function Reviews() {
    const [step, setStep] = useState('initial');
  const [selectedOption, setSelectedOption] = useState('');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


 
  return (
    <div className="bg-slate-900">
  {/* Hero Section */}
  <div className="relative md:h-[70vh] h-[40vh] overflow-hidden">
  {/* Background Video with Zoom Out */}
  <motion.div
    initial={{ scale: 1.2 }}
    animate={{ scale: 1 }}
    transition={{ duration: 3, ease: "easeOut" }}
    className="absolute inset-0"
  >
    <video
      className="w-full h-full object-cover"
      autoPlay
      loop
      muted
      playsInline
    >
      <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </motion.div>

  {/* Overlay */}
  <div className="absolute inset-0 bg-black bg-opacity-30" />

  {/* Heading on the Left */}
  <div className="relative z-10 h-full flex-col items-end sm:items-center justify-start px-5 sm:px-10 pb-10 sm:pb-0 ml-4 md:ml-8 md:mt-48 mt-36">
  <div className="relative inline-block">
  <motion.div
    initial={{ opacity: 0, y: 80 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 2, ease: "easeOut" }}
    className="bg-black bg-opacity-40 rounded-xl shadow-xl px-6 py-4"
  >
    <h1 className="text-white text-5xl sm:text-4xl md:text-7xl font-semibold leading-tight">
      Reviews
    </h1>
  </motion.div>

  <motion.div
    animate={{ y: [0, -14, 3, 0] }}
    transition={{ repeat: Infinity, duration: 3 }}
    className="absolute top-[-20px] left-[-20px] w-[70px] h-[80px] border-t-[22px] border-l-[22px] border-teal-500 opacity-25 "
  />
</div>
<motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, delay: 0.3 }}
        className="text-base sm:text-2xl text-white py-3"
      >
       We are passionate about providing you with the best services possible. See what Our Clients say about us. 
      </motion.p>

<div className="px-5 sm:px-10 py-10 max-w-7xl mx-auto text-left">
     
    </div>
    
  </div>
  
</div>









<div className="bg-white">

<div className="min-h-screen bg-gradient-to-br from-slate-100 to-slate-300 py-12 px-10 md:px-20">
      <h1 className="text-4xl font-bold text-center text-slate-800 mb-12">
        Customer Reviews
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {reviews.map((review) => (
          <ReviewCard key={review.id} {...review} />
        ))}
      </div>
    </div>



</div>






</div>

  
  );
}
